import { h } from 'preact';
import htm from 'htm';
import { IconClose } from './Icons.js';

const html = htm.bind(h);

export function ShareModal({ t, shareUrl, shareCopied, onClose, onCopy }) {
  if (!shareUrl) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return html`
    <div class="mta-share-overlay" onClick=${handleOverlayClick}>
      <div class="mta-share-dialog">
        <div class="mta-share-header">
          <span class="mta-share-title">${t('share_link_title')}</span>
          <button type="button" class="mta-icon-btn" onClick=${onClose} aria-label=${t('close')}>
            <${IconClose} />
          </button>
        </div>
        <p class="mta-share-desc">${t('share_link_description')}</p>
        <div class="mta-share-actions">
          <input
            type="text"
            readonly
            value=${shareUrl}
            onClick=${(e) => e.target.select()}
            class="mta-share-input"
          />
          <button
            type="button"
            onClick=${onCopy}
            class=${`mta-share-copy-btn ${shareCopied ? 'is-copied' : ''}`}
          >
            ${shareCopied ? t('copied') : t('copy')}
          </button>
        </div>
      </div>
    </div>
  `;
}
